import { Text } from '@/components/ui/text'
import { cn } from '@/lib'

interface EmptyStateProps {
  title?: string
  description?: string
  icon?: React.ReactNode
  className?: string
}

export const EmptyState = ({ title, description, icon, className }: EmptyStateProps) => {
  return (
    <div className='w-full flex justify-center mt-8'>
      <div className={cn('flex flex-col items-center gap-5 w-[19.5rem]', className)}>
        {icon}
        <div className='text-center'>
          <Text as='p' size={18}>
            {title}
          </Text>
          <Text as='p' color='white-48' className='mt-1'>
            {description}
          </Text>
        </div>
      </div>
    </div>
  )
}
